package com.appsyde.shared.modules.account.data

import kotlinx.serialization.Serializable

@Serializable
data class AccountResponseDto(
    val id: String,
    val primaryEmail: String,
    val tone: String,
    val signatureEnabled: Boolean = true,
    val signatureValue: String = ""
)

@Serializable
data class ToneUpdateRequestDto(val tone: String)

@Serializable
data class ToneUpdateResponseDto(val tone: String)

@Serializable
data class SignatureUpdateRequestDto(
    val signatureEnabled: Boolean,
    val signatureValue: String
)

@Serializable
data class SignatureUpdateResponseDto(
    val signatureEnabled: Boolean,
    val signatureValue: String
)

/** GET /me response: user, account, role, onboarding, gmail connection status, billing gate. */
@Serializable
data class MeResponseDto(
    val user: MeUserDto,
    val account: MeAccountDto,
    val role: String,
    val onboardingStatus: String?,
    val gmailConnectionStatus: String,
    val canUseProduct: Boolean = true,
    val mustSubscribe: Boolean = false,
    val isOwner: Boolean = false,
    val workspaceDisplayName: String = "",
    val membersCount: Int = 0,
    val subscriptionRequiredReason: String? = null
)

@Serializable
data class MeUserDto(val id: String, val email: String, val name: String? = null)

@Serializable
data class MeAccountDto(val id: String, val primaryEmail: String)

/** GET /billing/status response. */
@Serializable
data class BillingStatusDto(
    val billingStatus: String,
    val hasBillingAccess: Boolean,
    val trialEndsAt: String? = null,
    val daysRemainingTrial: Int? = null,
    val billingPlan: String? = null
)

/** POST /billing/checkout-session response. */
@Serializable
data class CheckoutSessionResponseDto(
    val url: String,
    val sessionId: String
)

/** POST /billing/customer-portal response. */
@Serializable
data class CustomerPortalResponseDto(
    val url: String
)
